<template>
  <div>
    <p>This ansible will be terminated. Are you sure?</p>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'

export default {
  name: 'TerminateAnsible',
  props: {
    confirmModal: Boolean,
  },
  methods: {
    confirm() {
      ApiService.delete(`ansible/playbook/${this.$route.params.id}`)
        .then(() => {
          this.$emit('resetDetailForm', true)
          setTimeout(() => {
            this.$generateToast(this, 'success', this.$t('global.successful'))
          }, 200)
          setTimeout(() => {
            this.$router.push('/services/ansible')
          }, 400)
        })
        .catch((err) => {
          this.$emit('resetDetailForm', false)
          setTimeout(() => {
            this.$generateToast(this, 'danger', err.message, true)
          }, 200)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>